import { BloomError } from '@jane/bloom/utils/errors/bloomError';
import { FetchError } from '@jane/bloom/utils/errors/fetchError';
import { logError } from '@jane/bloom/utils/logError';

type PostOptions = {
  body?: unknown;
  headers?: HeadersInit;
};

export const httpPost = async <T>(
  url: string,
  { body, headers }: PostOptions = {}
): Promise<T> => {
  const requestInit = body
    ? { body: JSON.stringify(body), headers, method: 'POST' }
    : { headers, method: 'POST' };

  const response = await fetch(url, requestInit);
  const text = await response.text(); // json in text
  if (!response.ok) {
    const err = new FetchError({
      request: {
        url: new URL(url),
        verb: 'POST',
      },
      response: {
        body: text,
        status: response.status,
      },
    });
    logError(err);
    throw err;
  }

  if (!text.startsWith('{')) {
    const err = new BloomError({
      context: {
        responseStatus: response.status,
        url,
        verb: 'POST',
      },
      message: `Error parsing response text into json`,
    });
    logError(err);
    throw err;
  }

  const parsed = JSON.parse(text);
  return parsed;
};
